<ng-container *ngIf="isStaticTooltip; else hoverTooltip">
    <div class="tooltip-container flex justify-center items-start cursor-pointer rounded-lg bg-neptune-subtle px-4 py-2 text-sm text-neptune-default gap-2">
        <img class="w-6 h-6 block" alt="info-icon" src="assets/shared-icons/neptune-icon-blue-info.svg"/>
        <span class="tooltip-content text-sm">
            {{ tooltipText }}
        </span>
    </div>
</ng-container>

<ng-template #hoverTooltip>
    <div class="tooltip-container relative group inline-flex items-center">
        <img class="w-9 h-9" alt="info-icon" src="assets/shared-icons/neptune-icon-blue-info.svg"/>

        <div
            class="tooltip-content pointer-events-none absolute right-0 -translate-x-1 translate-y-3/4 mt-2 z-50 hidden
                group-hover:block group-focus-within:block whitespace-normal max-w-xs
                rounded-md bg-neptune-subtle px-3 py-2 text-sm text-neptune-default shadow-lg min-w-64"
            role="tooltip"
        >
            {{ tooltipText }}
        </div>
    </div>
</ng-template>
